import { render, staticRenderFns } from "./AdminBitrixMonitor.vue?vue&type=template&id=7b0c1a2a&scoped=true"
import script from "./AdminBitrixMonitor.vue?vue&type=script&lang=js"
export * from "./AdminBitrixMonitor.vue?vue&type=script&lang=js"
import style0 from "./AdminBitrixMonitor.vue?vue&type=style&index=0&id=7b0c1a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0c1a2a",
  null
  
)

export default component.exports